import styled from 'styled-components';
import { Button } from 'antd';
import { FONTS } from 'utils/constants/styles';

const NewLinkButton = styled(Button)`
    white-space: initial;
    height: auto;
    color: ${props => props.theme.button.link} !important;
    background-color: transparent;
    border-color: ${props => props.theme.background.revertTheme};
    font-weight: ${FONTS.SEMI_BOLD};
    font-size: ${FONTS.DESCRIPTION_FONT_SIZE};
    border: none;
    padding: 0;

    span {
        text-decoration: underline;
    }

    &:hover {
        > span {
            color: ${props => props.theme.text.selected} !important;
        }
        color: ${props => props.theme.text.selected} !important;
    }
`;

export default NewLinkButton;
